module.exports = __webpack_public_path__ + "img/glry-5.9c5341b7.jpg";